export default {
  data: {
    get: function () {
      return this.getData();
    },
    set: function (d) {
      this.setData(d);
    },
  },
};
